import React, { useState, useEffect } from "react";
import withStyles from "utils/withStyles";
import { Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import styles from "./../Variant/styles";
import "./../Variant/styles.css";
import { AddButton, EditButton } from "../common/Buttons";
import ContentHeader from "../common/ContentHeader";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useSnackbar } from "notistack";
import { handleServerErrors } from "../../utiles/helpers";
import {
  enableLanguagesTab,
  enableVariantManagementTab,
  enableReportedCategoryTab,
  enableMultiPickupTab,
  setProductSettingsData,
} from "redux/actions";

import { Loader } from "./../../utiles/helpers";

const Settings = ({ setActiveTab }) => {
  const classes = styles();
  const productSettingsData = useSelector(
    (state) => state.initialLoadReducer.productSettingsData
  );
  const [productCheck, setProductCheck] = useState(
    productSettingsData["enable_subcategory"] ?? false
  );
  const [weightLimitCheck, setWeightLimitCheck] = useState(
    productSettingsData["enable_weight_limit"] ?? false
  );
  const [reportedCategoryCheck, setReportedCategoryCheck] = useState(
    productSettingsData["enable_reported_category"] ?? false
  );
  const [multiPickupCheck, setMultiPickupCheck] = useState(
    productSettingsData["enable_multi_pickup"] ?? false
  );
  const [metrcTagCheck, setMetrcTagCheck] = useState(
    productSettingsData["enable_metrc_tag"] ?? false
  );
  const [barCheck, setBarCheck] = useState(
    productSettingsData["enable_barcode"] ?? true
  );
  const [infoCheck, setInfoCheck] = useState(
    productSettingsData["enable_info_img"] ?? false
  );
  const [ingredientsCheck, setIngredientsCheck] = useState(
    productSettingsData["enable_ingredient_img"] ?? false
  );
  const [settingsData, setSettingsData] = useState(productSettingsData);
  const [loader, setLoader] = useState(false);
  const [recommendedProducts, setRecommendedProducts] = useState(
    productSettingsData["enable_recommend_product"] ?? false
  );
  const [productSorting, setProductSorting] = useState(
    productSettingsData["enable_planogram_product_sorting"] ?? false
  );
  const [productPopularity, setProductPopularity] = useState(
    productSettingsData["enable_product_popularity"] ?? false
  );
  const [productTimeRestriction, setProductTimeRestriction] = useState(
    productSettingsData["enable_product_selling_time"] ?? false
  );
  const [enableTax, setEnableTax] = useState(
    productSettingsData["enable_taxes_per_product"] ?? false
  );
  const [barcodeToDescription, setBarcodeToDescription] = useState(
    productSettingsData["change_barcode_to_desc_img"] ?? false
  );
  const [enableEmergencyProduct, setEnableEmergencyProduct] = useState(
    productSettingsData["enable_emergency_product_flag"] ?? false
  );
  const [enableProductInstructionalVideo, setEnableProductInstructionalVideo] =
    useState(productSettingsData["enable_video_description"] ?? false);
  const [enableProductLanguage, setEnableProductLanguage] = useState(
    productSettingsData["enable_product_language"] ?? false
  );
  const [enableVariantManagement, setEnableVariantManagement] = useState(
    productSettingsData["enable_variant_management"] ?? false
  );
  const [disableVariantManagement, setDisableVariantManagement] = useState(
    productSettingsData["has_variants"] ?? false
  );
  const [disableWeightLimit, setDisableWeightLimit] = useState(false);
  const [disableReportedCategory, setDisableReportedCategory] = useState(false);
  const [enableStoreProduct, setEnableStoreProduct] = useState(
    productSettingsData["enable_store_product"] ?? false
  );

  useEffect(() => {
    if (productSettingsData["enable_weight_limit"]) {
      setDisableReportedCategory(true);
    } else if (productSettingsData["enable_reported_category"]) {
      setDisableWeightLimit(true);
    }
  }, [productSettingsData]);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const handleCheckboxChange = (event, setState) => {
    setState(event.target.checked);
  };

  const getSubCategory = async () => {
    setLoader(true);
    window
      .axiosIns("/products_settings")
      .then(({ data = {} }) => {
        setSettingsData(data.results?.[0]);
        setProductCheck(Boolean(data.results?.[0]?.["enable_subcategory"]));
        setWeightLimitCheck(Boolean(data.results?.[0]?.["enable_weight_limit"]));
        setMultiPickupCheck(
          Boolean(data.results?.[0]?.["enable_multi_pickup"])
        );
        setMetrcTagCheck(Boolean(data.results?.[0]?.["enable_metrc_tag"]));
        setBarCheck(data.results?.[0]?.["enable_barcode"] ?? true);
        setInfoCheck(data.results?.[0]?.["enable_info_img"] ?? false);
        setIngredientsCheck(
          data.results?.[0]?.["enable_ingredient_img"] ?? false
        );
        setRecommendedProducts(
          data.results?.[0]?.["enable_recommend_product"] ?? false
        );
        setProductSorting(
          data.results?.[0]?.["enable_planogram_product_sorting"] ?? false
        );
        setProductPopularity(
          data.results?.[0]?.["enable_product_popularity"] ?? false
        );
        setProductTimeRestriction(
          data.results?.[0]?.["enable_product_selling_time"] ?? false
        );
        setEnableTax(data.results?.[0]?.["enable_taxes_per_product"] ?? false);
        setBarcodeToDescription(
          data.results?.[0]?.["change_barcode_to_desc_img"] ?? false
        );
        setEnableEmergencyProduct(
          data.results?.[0]?.["enable_emergency_product_flag"] ?? false
        );
        setEnableProductInstructionalVideo(
          data.results?.[0]?.["enable_video_description"] ?? false
        );
        setEnableProductLanguage(
          data.results?.[0]?.["enable_product_language"] ?? false
        );
        dispatch(
          enableLanguagesTab(
            data.results?.[0]?.["enable_product_language"] ?? false
          )
        );
        setEnableVariantManagement(
          data.results?.[0]?.["enable_variant_management"] ?? false
        );
        setDisableVariantManagement(
          data.results?.[0]?.["has_variants"] ?? false
        );
        setEnableStoreProduct(
          data.results?.[0]?.["enable_store_product"] ?? false
        );
        dispatch(
          enableVariantManagementTab(
            data.results?.[0]?.["enable_variant_management"] ?? false
          )
        );
        dispatch(
          enableReportedCategoryTab(
            data.results?.[0]?.["enable_reported_category"] ?? false
          )
        );
        dispatch(
          enableMultiPickupTab(
            data.results?.[0]?.["enable_multi_pickup"] ?? false
          )
        );
        setLoader(false);
      })
      .catch((err) => {
        if (err.detail) {
          enqueueSnackbar(err.detail);
        } else {
          handleServerErrors(
            err,
            enqueueSnackbar,
            "Could not get data. Try again."
          );
        }
        setLoader(false);
      });
  };

  const handleAdd = () => {
    const fd = new FormData();

    fd.append("enable_subcategory", productCheck);
    fd.append("enable_weight_limit", weightLimitCheck);
    fd.append("enable_reported_category", reportedCategoryCheck);
    fd.append("enable_multi_pickup", multiPickupCheck);
    fd.append("enable_metrc_tag", metrcTagCheck);
    fd.append("enable_barcode", barCheck ?? true);
    fd.append("enable_info_img", infoCheck ?? false);
    fd.append("enable_ingredient_img", ingredientsCheck ?? false);
    fd.append("enable_recommend_product", recommendedProducts ?? false);
    fd.append("enable_planogram_product_sorting", productSorting ?? false);
    fd.append("enable_product_popularity", productPopularity ?? false);
    fd.append("enable_product_selling_time", productTimeRestriction ?? false);
    fd.append("enable_taxes_per_product", enableTax ?? false);
    fd.append("change_barcode_to_desc_img", barcodeToDescription ?? false);
    fd.append("enable_emergency_product_flag", enableEmergencyProduct ?? false);
    fd.append(
      "enable_video_description",
      enableProductInstructionalVideo ?? false
    );
    fd.append("enable_product_language", enableProductLanguage ?? false);
    fd.append("enable_variant_management", enableVariantManagement ?? false);
    fd.append("enable_store_product", enableStoreProduct ?? false);
    //

    setLoader(true);

    settingsData && settingsData["id"]
      ? window.axiosIns
          .put(`/products_settings/${settingsData["id"]}`, fd)
          .then((data) => {
            dispatch(setProductSettingsData(data.data));
            enqueueSnackbar("Settings updated successfully.");
          })
          .catch((err) => {
            if (err.response.data.detail) {
              enqueueSnackbar(err.response.data.detail);
            } else {
              handleServerErrors(
                err,
                enqueueSnackbar,
                "Could not save settings. Try again."
              );
            }
          })
          .then(() => {
            setSettingsData(false);
            getSubCategory();
          })
      : window.axiosIns
          .post(`/products_settings`, fd)
          .then(() => {
            enqueueSnackbar("Settings updated successfully.");
          })
          .catch((err) => {
            if (err.response.data.detail) {
              enqueueSnackbar(err.response.data.detail);
            } else {
              handleServerErrors(
                err,
                enqueueSnackbar,
                "Could not save settings. Try again."
              );
            }
          })
          .then(() => {
            setSettingsData(false);
            getSubCategory();
          });
  };

  return (
    <div id="sa-modules-wrapper" className={classes.wrapper}>
      <ContentHeader
        title="Settings"
        description="
        Settings can be used to take advantage of product features like enabling sub-categories etc."
      />
      <div className={classes.toolbar}>
        <div className={classes.crudButtons}>
          <AddButton
            className="mr-3"
            label="Save"
            save="true"
            disabled={
              settingsData["id"] &&
              settingsData["enable_subcategory"] === productCheck &&
              settingsData["enable_barcode"] === barCheck &&
              settingsData["enable_info_img"] === infoCheck &&
              settingsData["enable_ingredient_img"] === ingredientsCheck &&
              settingsData["enable_recommend_product"] ===
                recommendedProducts &&
              settingsData["enable_planogram_product_sorting"] ===
                productSorting &&
              settingsData["enable_product_popularity"] === productPopularity &&
              settingsData["enable_product_selling_time"] ===
                productTimeRestriction &&
              settingsData["enable_taxes_per_product"] === enableTax &&
              settingsData["change_barcode_to_desc_img"] ===
                barcodeToDescription &&
              settingsData["enable_emergency_product_flag"] ===
                enableEmergencyProduct &&
              settingsData["enable_video_description"] ===
                enableProductInstructionalVideo &&
              settingsData["enable_product_language"] ===
                enableProductLanguage &&
              settingsData["enable_variant_management"] ===
                enableVariantManagement &&
              settingsData["enable_weight_limit"] === weightLimitCheck &&
              settingsData["enable_reported_category"] ===
                reportedCategoryCheck &&
              settingsData["enable_store_product"] === enableStoreProduct &&
              settingsData["enable_metrc_tag"] === metrcTagCheck &&
              multiPickupCheck &&
              settingsData["enable_multi_pickup"] === multiPickupCheck
            }
            onClick={() => handleAdd()}
          />
          <EditButton
            // disabled={modulesSelected.length !== 1 || current_user.type === 'SU'}
            className="mr-3"
            label="Cancel"
            cancel="true"
            onClick={() => {
              setActiveTab("product");
              window.history.replaceState(null, null, "?tab=product");
            }}
          />
        </div>
      </div>

      <div className={classes.settings}>
        <div className={classes.settings__product_features}>
          <Typography variant="title">Products Features</Typography>
        </div>
        {loader ? (
          <Loader visible={loader} />
        ) : (
          <div style={{ paddingBottom: "40px" }}>
            <div className={classes.settings__subcategory_checkbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={productCheck}
                    color="primary"
                    onChange={(e) => handleCheckboxChange(e, setProductCheck)}
                  />
                }
                label={
                  <span>
                    Enable Subcategories{" "}
                    <span style={{ opacity: 0.5 }}>
                      (Unavailable on Generic Software)
                    </span>
                  </span>
                }
              />
            </div>
            <div className={classes.settings__subcategory_checkbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={barCheck}
                    color="primary"
                    onChange={(e) => handleCheckboxChange(e, setBarCheck)}
                  />
                }
                label={
                  <span>
                    Enable Barcode{" "}
                    <span style={{ opacity: 0.5 }}>
                      (Unavailable on Generic Software)
                    </span>
                  </span>
                }
              />
              <div style={{ marginLeft: 20 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={barcodeToDescription}
                      color="primary"
                      onChange={(e) =>
                        handleCheckboxChange(e, setBarcodeToDescription)
                      }
                    />
                  }
                  label={
                    <span>
                      Change Barcode to Description Image{" "}
                      <span style={{ opacity: 0.5 }}>
                        (Unavailable on Generic Software)
                      </span>
                    </span>
                  }
                  disabled={!barCheck}
                />
              </div>
            </div>
            <div className={classes.settings__subcategory_checkbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={infoCheck}
                    color="primary"
                    onChange={(e) => handleCheckboxChange(e, setInfoCheck)}
                  />
                }
                label={
                  <span>
                    Enable more info images{" "}
                    <span style={{ opacity: 0.5 }}>
                      (Unavailable on Generic Software)
                    </span>
                  </span>
                }
              />
            </div>
            <div className={classes.settings__subcategory_checkbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={ingredientsCheck}
                    color="primary"
                    onChange={(e) =>
                      handleCheckboxChange(e, setIngredientsCheck)
                    }
                  />
                }
                label={
                  <span>
                    Enable ingredients image{" "}
                    <span style={{ opacity: 0.5 }}>
                      (Unavailable on Generic Software)
                    </span>
                  </span>
                }
              />
            </div>
            <div className={classes.settings__subcategory_checkbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={recommendedProducts}
                    color="primary"
                    onChange={(e) =>
                      handleCheckboxChange(e, setRecommendedProducts)
                    }
                  />
                }
                label={
                  <span>
                    Enable Recommended Products{" "}
                    <span style={{ opacity: 0.5 }}>
                      (Unavailable on Generic Software)
                    </span>
                  </span>
                }
              />
            </div>
            <div className={classes.settings__subcategory_checkbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={productSorting}
                    color="primary"
                    onChange={(e) => handleCheckboxChange(e, setProductSorting)}
                  />
                }
                label="Enable Product Ordering "
              />
            </div>
            <div className={classes.settings__subcategory_checkbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={productPopularity}
                    color="primary"
                    onChange={(e) =>
                      handleCheckboxChange(e, setProductPopularity)
                    }
                  />
                }
                label={
                  <span>
                    Enable Product Popularity{" "}
                    <span style={{ opacity: 0.5 }}>
                      (Unavailable on Generic Software)
                    </span>
                  </span>
                }
              />
            </div>
            <div className={classes.settings__subcategory_checkbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={productTimeRestriction}
                    color="primary"
                    onChange={(e) =>
                      handleCheckboxChange(e, setProductTimeRestriction)
                    }
                  />
                }
                label="Enable Product Restriction based on Time"
              />
            </div>
            <div className={classes.settings__subcategory_checkbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={enableTax}
                    color="primary"
                    onChange={(e) => handleCheckboxChange(e, setEnableTax)}
                  />
                }
                label="Enable Tax on Product and Variant"
              />
            </div>
            <div className={classes.settings__subcategory_checkbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={enableEmergencyProduct}
                    color="primary"
                    onChange={(e) =>
                      handleCheckboxChange(e, setEnableEmergencyProduct)
                    }
                  />
                }
                label={
                  <span>
                    Enable Emergency Product Dispensing{" "}
                    <span style={{ opacity: 0.5 }}>
                      (Unavailable on Generic Software)
                    </span>
                  </span>
                }
              />
            </div>
            <div className={classes.settings__subcategory_checkbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={enableProductInstructionalVideo}
                    color="primary"
                    onChange={(e) =>
                      handleCheckboxChange(
                        e,
                        setEnableProductInstructionalVideo
                      )
                    }
                  />
                }
                label={
                  <span>
                    Enable Product Instructions Video{" "}
                    <span style={{ opacity: 0.5 }}>
                      (Unavailable on Generic Software)
                    </span>
                  </span>
                }
              />
            </div>
            <div className={classes.settings__subcategory_checkbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={enableProductLanguage}
                    color="primary"
                    onChange={(e) =>
                      handleCheckboxChange(e, setEnableProductLanguage)
                    }
                  />
                }
                label={
                  <span>
                    Enable Product Language{" "}
                    <span style={{ opacity: 0.5 }}>
                      (Unavailable on Generic Software)
                    </span>
                  </span>
                }
              />
            </div>
            <div className={classes.settings__subcategory_checkbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={enableVariantManagement}
                    disabled={disableVariantManagement}
                    color="primary"
                    onChange={(e) =>
                      handleCheckboxChange(e, setEnableVariantManagement)
                    }
                  />
                }
                label={<span>Enable Variant Management</span>}
              />
            </div>
            <div className={classes.settings__subcategory_checkbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={enableStoreProduct}
                    color="primary"
                    onChange={(e) =>
                      handleCheckboxChange(e, setEnableStoreProduct)
                    }
                  />
                }
                label={<span>Enable Store Product Purchase</span>}
              />
            </div>
            <div className={classes.settings__subcategory_checkbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={weightLimitCheck}
                    disabled={disableWeightLimit}
                    color="primary"
                    onChange={(e) => {
                      handleCheckboxChange(e, setWeightLimitCheck);
                      setReportedCategoryCheck(false);
                      setDisableReportedCategory(e.target.checked);
                    }}
                  />
                }
                label={
                  <span>Enable Category-wise Purchase Limit by Weight</span>
                }
              />
            </div>
            <div className={classes.settings__subcategory_checkbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={reportedCategoryCheck}
                    disabled={disableReportedCategory}
                    color="primary"
                    onChange={(e) => {
                      handleCheckboxChange(e, setReportedCategoryCheck);
                      setWeightLimitCheck(false);
                      setDisableWeightLimit(e.target.checked);
                    }}
                  />
                }
                label={
                  <span>
                    Enable Reported Category-wise Purchase Weight Limit
                  </span>
                }
              />
            </div>
            <div className={classes.settings__subcategory_checkbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={multiPickupCheck}
                    disabled={false}
                    color="primary"
                    onChange={(e) => {
                      handleCheckboxChange(e, setMultiPickupCheck);
                    }}
                  />
                }
                label={
                  <span>
                    Enable Multi Pickup for m-series devices
                  </span>
                }
              />
            </div>
            <div className={classes.settings__subcategory_checkbox}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={metrcTagCheck}
                    disabled={false}
                    color="primary"
                    onChange={(e) => {
                      handleCheckboxChange(e, setMetrcTagCheck);
                    }}
                  />
                }
                label={<span>Enable METRC Tag</span>}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default withStyles({}, { withTheme: true })(Settings);
